import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 48,
	height: 50,
	viewBox: "0 0 48 50",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M34.138 23.033c0-5.959-3.99-10.07-9.95-10.07a9.8 9.8 0 0 0-10.19 10.19c0 5.236 5.874 10.79 5.874 14.985h8.392c0-2.997 5.874-9.478 5.874-15.105Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.063 39.816a1.678 1.678 0 0 1-1.678 1.678h-8.393a1.678 1.678 0 0 1 0-3.356h8.392a1.677 1.677 0 0 1 1.678 1.678Zm0 3.357a1.678 1.678 0 0 1-1.678 1.678h-8.393a1.679 1.679 0 0 1 0-3.357h8.392a1.68 1.68 0 0 1 1.678 1.68Z",
			fill: "#D1C8FE",
			stroke: "#531DAB",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.384 44.851a4.2 4.2 0 0 1-8.392 0h8.392Z",
			fill: "#fff",
			stroke: "#531DAB",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.138 23.033c0-5.959-3.99-10.07-9.95-10.07a9.8 9.8 0 0 0-10.19 10.19c0 5.236 5.874 10.79 5.874 14.985h8.392c0-2.997 5.874-9.478 5.874-15.105Z",
			stroke: "#531DAB",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m23.23 38.138-3.736-11.2a1.91 1.91 0 0 1 3.164-1.956 1.992 1.992 0 0 0 2.82 0 1.911 1.911 0 0 1 3.16 1.953l-3.735 11.2",
			stroke: "#531DAB",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m42.072 39.011 2.343 1.874m-1.377-11.501 2.999-.036m-3.03-13.027 2.876-.853M35.5 7.827l1.856-2.357m-12.69-.637v-3M13.491 8.719 12.15 6.036M5.961 17.01l-2.572-1.544M4.667 28.5h-3m8.01 10.406L7.334 40.78",
			stroke: "#531DAB",
			strokeLinecap: "round",
			strokeWidth: 2
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2248%22%20height%3D%2250%22%20viewBox%3D%220%200%2048%2050%22%3E%3Cpath%20d%3D%22M34.138%2023.033c0-5.959-3.99-10.07-9.95-10.07a9.8%209.8%200%200%200-10.19%2010.19c0%205.236%205.874%2010.79%205.874%2014.985h8.392c0-2.997%205.874-9.478%205.874-15.105Z%22%20fill%3D%22%23fff%22%2F%3E%3Cpath%20d%3D%22M30.063%2039.816a1.678%201.678%200%200%201-1.678%201.678h-8.393a1.678%201.678%200%200%201%200-3.356h8.392a1.677%201.677%200%200%201%201.678%201.678Zm0%203.357a1.678%201.678%200%200%201-1.678%201.678h-8.393a1.679%201.679%200%200%201%200-3.357h8.392a1.68%201.68%200%200%201%201.678%201.68Z%22%20fill%3D%22%23D1C8FE%22%20stroke%3D%22%23531DAB%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M28.384%2044.851a4.2%204.2%200%200%201-8.392%200h8.392Z%22%20fill%3D%22%23fff%22%20stroke%3D%22%23531DAB%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M34.138%2023.033c0-5.959-3.99-10.07-9.95-10.07a9.8%209.8%200%200%200-10.19%2010.19c0%205.236%205.874%2010.79%205.874%2014.985h8.392c0-2.997%205.874-9.478%205.874-15.105Z%22%20stroke%3D%22%23531DAB%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22m23.23%2038.138-3.736-11.2a1.91%201.91%200%200%201%203.164-1.956%201.992%201.992%200%200%200%202.82%200%201.911%201.911%200%200%201%203.16%201.953l-3.735%2011.2%22%20stroke%3D%22%23531DAB%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22m42.072%2039.011%202.343%201.874m-1.377-11.501%202.999-.036m-3.03-13.027%202.876-.853M35.5%207.827l1.856-2.357m-12.69-.637v-3M13.491%208.719%2012.15%206.036M5.961%2017.01l-2.572-1.544M4.667%2028.5h-3m8.01%2010.406L7.334%2040.78%22%20stroke%3D%22%23531DAB%22%20stroke-linecap%3D%22round%22%20stroke-width%3D%222%22%2F%3E%3C%2Fsvg%3E";
